<template>
	<div class="wrap">
		<div class="banner">
			<div class="banner-cont">
				<div class="swiper-container swiper-banner">
					<div class="swiper-wrapper">
						<div class="swiper-slide"><img src="../assets/index/38201876_l.jpg" alt=""></div>
						<div class="swiper-slide"><img src="../assets/agent/banner.jpg" alt=""></div>
					</div>
					<div class="swiper-button-next"></div>
					<div class="swiper-button-prev"></div>
				</div>
			</div>
			<span class="insidebanner-bor"></span>
		</div>
		<div class="content">
			<div class="edu">
				<div class="edu-cont">
					<img src="../assets/index/01.png" alt="" class="edu-cont-pic reveal-left">
					<div class="edu-cont-txt">
						<div class="htitle">
							<h4>覆盖三端的互联网平台 <br>全面赋能幼教行业</h4>
							<img src="../assets/index/title_1.png" alt="">
						</div>
						<p>以儿童营养膳食为核心的幼儿园综合管理系统</p>
						<p>以幼师培训课程、信息化班级管理为核心的教师端应用</p>
						<p>以家园互动、家长学习为核心的家长端应用</p>
						<router-link to="/pomelo" class="more">了解详情</router-link>
					</div>

				</div>
			</div>
			<div class="series">
				<div class="series-cont">
					<div class="series-cont-txt">
						<div class="htitle">
							<h4>专业、省心、一站式服务<br> 打造品质幼儿园</h4>
							<img src="../assets/index/title_2.png" alt="">
						</div>
						<img src="../assets/index/series.png" alt="">
						<router-link to="/partner" class="more">了解详情</router-link>
					</div>
					<img src="../assets/index/02.png" alt="" class="series-cont-pic reveal-right">
				</div>
			</div>
			<div class="course">
				<div class="course-cont">
					<img src="../assets/index/03.png" alt="" class="course-cont-pic reveal-left">
					<div class="course-cont-txt">
						<div class="htitle">
							<h4>先进的教学理念</h4>
							<img src="../assets/index/title_3a.png" alt="">
							<h4>完整的课程体系</h4>
							<img src="../assets/index/title_3b.png" alt="">
							<h4>完善的服务支持</h4>
							<img src="../assets/index/title_3c.png" alt="">
						</div>
						<img src="../assets/index/series_book.png" alt="">
						<p>
							<span>•创享美学课程</span>
							<span>•体适能课程</span>
							<span>•国际双语美食课程</span>
						</p>
						<router-link to="/course" class="more">了解详情</router-link>
					</div>
				</div>
			</div>
			<div class="standard">
				<div class="standard-title">
					<h4>合作案例展示</h4>
					<img src="../assets/index/standard_for_partnering.png" alt="">
					<span class="standard-title-bor"></span>
				</div>
				<div class="standard-cont swiper-no-swiping">
					<div class="swiper-container swiper-standard garden">
						<div class="swiper-wrapper">
							<div class="swiper-slide"><img src="../assets/index/cangzhou.jpg" alt=""></div>
							<div class="swiper-slide swiper-slide-active"><img src="../assets/index/tongliao.jpg" alt=""></div>
							<div class="swiper-slide"><img src="../assets/index/baoji.jpg" alt=""></div>
							<div class="swiper-slide"><img src="../assets/index/shanghai.jpeg" alt=""></div>
						</div>

						<!-- 如果需要导航按钮 -->
						<div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div>
					</div>
					<div class="swiper-container swiper-type garden">
						<div class="swiper-wrapper">
							<div class="swiper-slide standard-box">
								<h4>河北沧州合伙人园所</h4>
								<div class="standard-box-cont">
									<p>建筑面积3500平米，室外活动4500平米，可接收300名学生，满员年营业额将达1200万以上；</p>
									<p>打造烹饪教室、游泳池、多功能厅、音乐室、阅读室、市内运动场等一系列特色设施；</p>
									<p>使用合伙人国际英语和蒙氏课程作为幼儿园特色课程；</p>
									<p>招生阶段，合伙人深入市调，推荐有效招生方案，开业即取得不俗的招生成绩；</p>
									<p>后续运营支持的持续跟进，园所稳步运营，打造成当地具有竞争力的高端园所。</p>
								</div>
							</div>
							<div class="swiper-slide standard-box">
								<h4>内蒙古通辽合伙人园所</h4>
								<div class="standard-box-cont">
									<p>建筑面积6000平米，室外活动场地12000平米。</p>
									<p>室内设有星空剧场、钢琴教室、国学馆、美术馆、亲自烘焙、沙盘教室、感统教室、科学连廊等；</p>
									<p>室外设备有动物园、戏水泳池、亲子种植园、大型体能拓展设施、轮滑场等；</p>
									<p>以合伙人提供的融合主体课程、国际英文课程为主，辅以生活家美术课和自研国学课和感统课，形成独有的课程特色体系；</p>
									<p>KA给到资深教育投资者更多在高端国际园所的运营经验和系统标准。</p>
								</div>
							</div>
							<div class="swiper-slide standard-box">
								<h4>陕西宝鸡合伙人园所</h4>
								<div class="standard-box-cont">
									<p>室内面积 4800平米，室外活动面积2400平米；</p>
									<p>设有社会体验区、种植区、沙地、种植区、游泳馆和小厨房等特色设施；</p>
									<p>以合伙人生活艺术家课和国学、体能、游泳、烘焙等为特色课程；</p>
									<p>开园前KA合伙人为宝鸡投资者提供充足而完善的市场调研、营销支持、招生支持和人事体系持；</p>
									<p>开园后持续跟进教师和运营人员的培训督导及课程支持，保证师资和运营质量高端。</p>
								</div>
							</div>
							<div class="swiper-slide standard-box">
								<h4>上海松江合伙人园所</h4>
								<div class="standard-box-cont">
									
									<p>幼儿园室内面积3000平米，室外活动面积1800平米，坐落于上海市松江区辰花路莱顿小城北门（靠近松江万达广场、松江大学城）。</p>
									<p>我园以牛津阅读树课程、美国加州Wonders幼儿园阶段课程、音乐启蒙课、幼儿形体礼仪和幼儿模特启蒙、幼儿演讲与口才、创意美术课、STEAM课程、幼儿街舞课等为特色课程。</p>
									<p>以先进的教育理念，完整的课程体系及周到细致的服务，为家长和孩子助力。</p>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="aboutus">
				<div class="aboutus-cont">
					<img src="../assets/index/aboutus_logo.png" alt="">
					<div class="aboutus-title">
						<span class="aboutus-zh">关于我们</span>
						<img src="../assets/index/about_us.png" alt="">
						<!-- <strong class="aboutus-en">About Us</strong> -->
					</div>
					<div class="aboutus-subtitle">
						<h4>伊顿国际教育集团旗下品牌</h4>
						<span>Etonkids Educational Group Sub-Brand Platform</span>
					</div>
					<div class="aboutus-txt">
						<p>在2017年规模化总结和梳理了Etonkids17年高端园所运营管理经验，<br>KA儿童之家正式上线，遵循独特的3C价值教育理念，致力于塑造孩子的5大特质，<br>旨在将Etonkids17年自营高端园所的优秀教学内容和教育服务惠及到国内广大幼儿园。<br>赋能幼儿园、教师和家长，从而让更多的孩子与家庭可以享受到更高品质的教育与服务。</p>
						<p>KA拥有来自Etonkids国际幼儿园17年的独特教育资源，全国17个城市51个中高端园所的运营管理经验，<br>一流的国内外专家、国际认证资质的教师及研发团队，哈佛大学、斯坦福大学和西北大学联合资源支持，AMS认证机构且拥有实践基地。</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import scrollReveal from 'scrollreveal';
	export default {
	  name: 'Index',
	  data () {
			return {
				scrollReveal: scrollReveal()
			}
		},
		mounted () {
      let garden = new Swiper ('.garden', {
      	loop: true,
      	nextButton: '.swiper-button-next',
      	prevButton: '.swiper-button-prev',
      	slidesPerView: 'auto',
      	centeredSlides: true,
      	paginationClickable: true,
      	spaceBetween: 12
       });

      let banner = new Swiper ('.swiper-banner', {
      	autoplay: true,
      	loop: true,
      	nextButton: '.swiper-button-next',
      	prevButton: '.swiper-button-prev',
      	effect: 'fade',
      	speed: 2500
       });

			this.scrollReveal.reveal('.reveal-left', {
				// 动画的时长
				duration: 1500,
				// 延迟时间
				delay: 200,
				// 动画开始的位置，'bottom', 'left', 'top', 'right'
				origin: 'left',
				// 回滚的时候是否再次触发动画
				reset: false,
				// 滚动的距离，单位可以用%，rem等
				distance: '600px',
		  });
		  this.scrollReveal.reveal('.reveal-right', {
				duration: 1500,
				delay: 200,
				origin: 'right',
				reset: false,
				distance: '600px',
		  });

		}
	}
</script>

<style lang="scss" scoped>
	@import '../base/scss/mixin';
	.content {
		z-index: 100;
	}
	.banner {
		width: 100%;
		position: relative;
		margin: 0 auto;
		&-cont {
			position: relative;
			top: 0;
			padding: 0;
			*zoom: 1;
			-ms-touch-action: pan-y;
			img {
				width: 100%;
				margin: 0 auto;
				display: block;
			}
		}
		.insidebanner-bor {
			z-index: 99;
			bottom: -182px;
		}
		.swiper-button-prev,
		.swiper-button-next {
			top: 43.5%;
		}
		.swiper-button-prev {
			left: 16%;
			// left: 308px;
		}
		.swiper-button-next {
			right: 16%;
			// right: 308px;
		}
	}
	.edu {
		height: 705px;
		background: url(../assets/index/04_1.jpg) center top no-repeat;
		&-cont {
			@extend %width;
			height: 705px - 130px;
			padding-top: 130px;
			position: relative;
			&-pic {
				position: absolute;
				left: 80px;
				bottom: 45px;
				width: 538px;
			}
			&-txt {
				float: right;
				padding-right: 20px;
				color: #111b3d;
				p {
					letter-spacing: 1px;
					line-height: 26px;
					font-size: 14px;
				}
				.more {
					margin-top: 110px;
					margin-left: 80px;
				}
			}

		}
		.htitle {
			h4 {
				margin-bottom: 25px - 9px;
			}
			img {
				margin-bottom: 30px;
			}
		}
	}
	.series {
		height: 804px;
		background: url(../assets/index/04_2.jpg) center no-repeat;
		&-cont {
			@extend %width;
			height: 804px;
			position: relative;
			&-txt {
				width: 388px;
				padding-top: 140px;
				margin-left: 40px;
			}
			&-pic {
				position: absolute;
				right: 76px;
				top: 153px;
			}
			.htitle {
				margin-bottom: 45px;
				h4 {
					margin-bottom: 24px - 9px;
				}
			}
			.more {
				display: block;
				margin: 50px auto 0;
			}
		}
	}
	.course {
		height: 888px;
		background: url(../assets/index/04_3.jpg) center top no-repeat;
		&-cont {
			@extend %width;
			@extend %clearfix;
			position: relative;
			padding-top: 165px;
			&-txt {
				float: right;
				margin-right: 12px;
			}
			&-pic {
				position: absolute;
				left: 42px;
				bottom: -34px;
			}
			p {
				// width: 355px;
				margin-bottom: 74px - 27px;
				padding-top: 20px;
				letter-spacing: 1px;
				font-size: 16px;
				color: #223d73;
				span {
					margin-right: 30px;
				}
			}
		}
		.htitle {
			margin-bottom: 32px;
			img {
				margin-bottom: 8px;
			}
		}
		.more {
			margin-left: 160px;
		}
	}
	.standard {
		height: 917px;
		background: url(../assets/index/54370615_l.jpg) center top no-repeat;
		border-bottom: 10px solid #e8374a;
		margin-bottom: 88px;
		&-title {
			text-align: center;
			padding-top: 44px;
			margin-bottom: 35px;
			h4 {
				margin-bottom: 10px;
				font-weight: normal;
				font-size: 28px;
				color: #e3b020;
			}
			&-bor {
				display: block;
				margin: 10px auto 0;
				width: 160px;
				height: 7px;
				background: #e8374a;
			}
		}
		&-cont {
			@extend %width;
		}
		&-box {
			width: 1048px - 120px;
			height: 297px - 28px;
			border-radius: 10px;
			background: #fff;
			box-shadow: 0 0 9px rgba(0,0,0,.4);
			padding: 28px 60px 0;
			margin: 0 auto;
			h4 {
				width: 447px;
				@include lh(48px);
				border-radius: 10px;
				background: #5385d6;
				margin: 0 auto 48px;
				font-weight: normal;
				font-size: 24px;
				color: #fff;
			}
			p {
				margin-bottom: 15px;
				font-size: 14px;
			}
		}
		.swiper-standard {
			// .swiper-container {
				height: 345px;
				margin-bottom: 64px;
			// }
			.swiper-wrapper {
				width: 468px;
			}
			.swiper-slide {
				width: 468px;
				height: 345px - 36px;
				// transform: scale(0.85);
				border-radius: 10px;
				padding-top: 36px;

				// background: #84a6dd;
				overflow: hidden;
				position: relative;
				// margin: 36px 12px 0 0;
				&::before {
					content: "";
					position: absolute;
					top: 36px;
					width: 325px;
					height: 240px;
					background: #000;
					border-radius: 10px;
					@include opacity(60);
				}
				img {
					width: 325px;
					height: 240px;
					border-radius: 10px;
				}
			}
			.swiper-slide-prev {
				text-align: right;
				&::before {
					right: 0;
				}
			}
			.swiper-slide-next {
				&::before {
					left: 0;
				}
			}
			.swiper-slide-active {
				padding-top: 0;
				// height: 345px;
				width: 464px;
				height: 341px;
				 border: 2px solid #fff;
				img {
					width: 100%;
					height: 100%;
				}
				// transform: scale(1);
				// margin: 0;
				// margin-top: 0;
				&::before {
					@include opacity(0);
				}
			}
			.swiper-button-prev,
			.swiper-button-next {
				margin-top: 0;
				top: 124px;
			}
			.swiper-button-prev {
				left: 140px;
			}
			.swiper-button-next {
				right: 140px;
			}
		}
		.swiper-type {
			width: 1048px;
		}
	}
	.aboutus {
		margin-bottom: 33px;
		background: url(../assets/partner/bg.jpg) left top repeat-y;
		&-cont {
			width: 1090px;
			height: 622px - 36px;
			padding-top: 36px;
			text-align: center;
			margin: 0 auto;
			background: url(../assets/index/aboutus_bg.png) left top no-repeat;
		}
		&-title {
			// width: 390px;
			width: 345px;
			@include lh(44px)
			border-radius: 6px;
			background: #fabe1b;
			margin: 30px auto;
			font-size: 0;
			color: #fafafa;
			span {
				margin-right: 30px;
				font-size: 28px;
			}
			span, img {
				vertical-align: middle;

			}
		}
// 		&-en {
// 			font-weight: bold;
// 			margin-left: 25px;
// 		}
		&-subtitle {
			margin-bottom: 26px;
			color: #1d50a2;
			h4 {
				margin-bottom: 12px;
				letter-spacing: 2px;
				font-weight: normal;
				font-size: 20px;
			}
			span {
				letter-spacing: 1px;
				font-size: 16px;
			}
		}
		&-txt {
			p {
				line-height: 27px;
				margin-bottom: 24px;
			}
		}
	}

	.htitle {
		h4 {
			letter-spacing: 3px;
			line-height: 36px;
			font-weight: normal;
			font-size: 28px;
			color: #1c50a1;
		}
	}
	.more {
		display: inline-block;
		width: 150px - 4px;
		@include lh(42px)
		border: 2px solid #f4bc16;
		// box-shadow: inset 0 0 6px #f4bc16;
		border-radius: 10px;
		background: #fff;
		font-size: 16px;
		color: #333;
		transition: all ease .35s;
		&:hover {
			background: #e5384d;
			border-color: #e5384d;
			color: #fff;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue